import { Box } from "@mantine/core";
import { FeedbackTable } from "../../../components/feedback-table/FeedbackTable";

const FeedbackInboxPage = () => {
    return (
        <Box style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <FeedbackTable maxHeight="100%" />
        </Box>
    );
};

export default FeedbackInboxPage;
